export default "__VITE_ASSET__ee9b6015__"